module.exports = __webpack_public_path__ + "img/dm.9049968f.png";